import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { Mail } from 'lucide-react';

export const Footer = () => {
  const [email, setEmail] = useState('');
  const [subscribed, setSubscribed] = useState(false);

  const handleSubscribe = (e) => {
    e.preventDefault();
    if (email) {
      setSubscribed(true);
      setEmail('');
    }
  };

  return (
    <footer className="bg-black text-white" data-testid="footer">
      {/* Newsletter Section */}
      <div className="border-b border-white/10">
        <div className="max-w-7xl mx-auto px-6 md:px-12 py-16">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8 items-center">
            <div>
              <h3 className="text-2xl font-light mb-2">Rimani aggiornato</h3>
              <p className="text-white/50 text-sm font-light">
                Iscriviti per ricevere accesso anticipato alle nuove selezioni e vantaggi esclusivi.
              </p>
            </div>
            <form onSubmit={handleSubscribe} className="flex gap-3">
              {subscribed ? (
                <p className="text-sm text-white/70">Grazie per l'iscrizione.</p>
              ) : (
                <>
                  <input
                    type="email"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    placeholder="Inserisci la tua email"
                    className="flex-1 px-4 py-3 bg-white/5 border border-white/10 text-sm text-white placeholder:text-white/30 focus:outline-none focus:border-white/30 transition-colors"
                  />
                  <button
                    type="submit"
                    className="px-6 py-3 bg-white text-black text-sm uppercase tracking-[0.1em] hover:bg-white/90 transition-colors"
                  >
                    Iscriviti
                  </button>
                </>
              )}
            </form>
          </div>
        </div>
      </div>

      {/* Main Footer */}
      <div className="max-w-7xl mx-auto px-6 md:px-12 py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12">
          {/* Brand */}
          <div className="lg:col-span-1">
            <h3 className="text-2xl font-light tracking-[0.3em] mb-6">QANTRI</h3>
            <p className="text-white/50 text-sm font-light leading-relaxed">
              Lo shopping online semplice, veloce e affidabile.
              <br />
              +2.300 prodotti selezionati con spedizione rapida.
            </p>
            
            {/* Trust Badges */}
            <div className="mt-6 flex flex-wrap gap-3">
              <div className="flex items-center gap-2 bg-white/5 rounded-full px-3 py-1.5">
                <span className="text-sm">🔒</span>
                <span className="text-xs text-white/60">Pagamento Sicuro</span>
              </div>
              <div className="flex items-center gap-2 bg-white/5 rounded-full px-3 py-1.5">
                <span className="text-sm">🚚</span>
                <span className="text-xs text-white/60">Spedizione Rapida</span>
              </div>
              <div className="flex items-center gap-2 bg-white/5 rounded-full px-3 py-1.5">
                <span className="text-sm">📞</span>
                <span className="text-xs text-white/60">Assistenza 24/7</span>
              </div>
            </div>
          </div>

          {/* Shop */}
          <div>
            <h4 className="text-xs uppercase tracking-[0.2em] text-white/40 mb-6">Collezioni</h4>
            <ul className="space-y-3">
              <li>
                <Link to="/products" className="text-sm text-white/70 hover:text-white transition-colors font-light">
                  Tutte le Collezioni
                </Link>
              </li>
              <li>
                <Link to="/products?category=moda" className="text-sm text-white/70 hover:text-white transition-colors font-light">
                  Moda & Accessori
                </Link>
              </li>
              <li>
                <Link to="/products?category=gioielli" className="text-sm text-white/70 hover:text-white transition-colors font-light">
                  Gioielli & Orologi
                </Link>
              </li>
              <li>
                <Link to="/products?category=bellezza" className="text-sm text-white/70 hover:text-white transition-colors font-light">
                  Bellezza & Skincare
                </Link>
              </li>
              <li>
                <Link to="/products?category=casa" className="text-sm text-white/70 hover:text-white transition-colors font-light">
                  Casa & Design
                </Link>
              </li>
              <li>
                <Link to="/products?category=elettronica" className="text-sm text-white/70 hover:text-white transition-colors font-light">
                  Tech & Elettronica
                </Link>
              </li>
              <li>
                <Link to="/products?category=fitness" className="text-sm text-white/70 hover:text-white transition-colors font-light">
                  Fitness & Wellness
                </Link>
              </li>
              <li>
                <Link to="/products?category=outdoor" className="text-sm text-white/70 hover:text-white transition-colors font-light">
                  Outdoor & Camping
                </Link>
              </li>
            </ul>
          </div>

          {/* Assistenza */}
          <div>
            <h4 className="text-xs uppercase tracking-[0.2em] text-white/40 mb-6">Assistenza</h4>
            <ul className="space-y-3">
              <li>
                <Link to="/chi-siamo" className="text-sm text-white/70 hover:text-white transition-colors font-light">
                  Chi Siamo
                </Link>
              </li>
              <li>
                <Link to="/support" className="text-sm text-white/70 hover:text-white transition-colors font-light">
                  Contattaci
                </Link>
              </li>
              <li>
                <Link to="/faq" className="text-sm text-white/70 hover:text-white transition-colors font-light">
                  FAQ & Normative
                </Link>
              </li>
              <li>
                <Link to="/support" className="text-sm text-white/70 hover:text-white transition-colors font-light">
                  Resi e Rimborsi
                </Link>
              </li>
            </ul>
          </div>

          {/* Extra */}
          <div>
            <h4 className="text-xs uppercase tracking-[0.2em] text-white/40 mb-6">Scopri</h4>
            <ul className="space-y-3">
              <li>
                <Link to="/news" className="text-sm text-white/70 hover:text-white transition-colors font-light">
                  Magazine
                </Link>
              </li>
              <li>
                <Link to="/courses" className="text-sm text-white/70 hover:text-white transition-colors font-light">
                  Academy
                </Link>
              </li>
              <li>
                <Link to="/referral" className="text-sm text-[#D4AF37] hover:text-[#B8962D] transition-colors font-light flex items-center gap-2">
                  Programma Referral
                  <span className="text-[9px] bg-[#D4AF37] text-black px-1.5 py-0.5 rounded-full">€5</span>
                </Link>
              </li>
              <li>
                <Link to="/partner" className="text-sm text-white/70 hover:text-white transition-colors font-light">
                  Diventa Partner
                </Link>
              </li>
              <li>
                <Link to="/sell" className="text-sm text-[#10B981] hover:text-[#059669] transition-colors font-medium flex items-center gap-2">
                  Vendi su QANTRI
                  <span className="text-[9px] bg-[#10B981] text-white px-1.5 py-0.5 rounded-full">NEW</span>
                </Link>
              </li>
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 className="text-xs uppercase tracking-[0.2em] text-white/40 mb-6">Contatti</h4>
            <ul className="space-y-4">
              <li className="flex items-center gap-3 text-white/70 text-sm font-light">
                <Mail className="h-4 w-4 text-white/40" />
                <span>postmaster@qantri.store</span>
              </li>
            </ul>
          </div>
        </div>
      </div>

      {/* Bottom Bar */}
      <div className="border-t border-white/10">
        <div className="max-w-7xl mx-auto px-6 md:px-12 py-6">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4">
            <p className="text-white/40 text-xs font-light">
              © {new Date().getFullYear()} QANTRI. Tutti i diritti riservati.
            </p>
            <div className="flex gap-6">
              <Link to="/privacy" className="text-white/40 hover:text-white/70 text-xs font-light transition-colors">
                Privacy Policy
              </Link>
              <Link to="/terms" className="text-white/40 hover:text-white/70 text-xs font-light transition-colors">
                Termini e Condizioni
              </Link>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
